import React from "react";
import { Modal, Button } from "antd";
import {
  IdcardOutlined,
  PlusOutlined,
  WarningOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const SeatGatekeeperModal = ({ visible, onClose, type, seatData }) => {
  const navigate = useNavigate();

  const totalSeats = seatData?.seats?.total_seats ?? 0;
  const usedSeats = seatData?.seats?.used_seats ?? 0;
  const remainingSeats = seatData?.seats?.remaining_seats ?? Math.max(0, totalSeats - usedSeats);

  // If user has active seats (> 0) and 0 remaining, it is ALWAYS Seat Limit Reached
  const isLimitReached = (totalSeats > 0 && remainingSeats <= 0) || type === "limit_reached";

  const handleAction = () => {
    onClose();
    if (isLimitReached) {
      navigate("/installer/subscription?mode=add_more");
    } else {
      navigate("/installer/subscription");
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      centered
      width={460}
      className="responsive-sub-modal"
      destroyOnClose
    >
      <div style={{ textAlign: "center", padding: "12px 4px 4px 4px" }}>
        {/* Icon Circle */}
        <div
          style={{
            width: "56px",
            height: "56px",
            borderRadius: "16px",
            background: isLimitReached ? "#fff7ed" : "#f0f9ff",
            color: isLimitReached ? "#ea580c" : "#0284c7",
            border: isLimitReached ? "1.5px solid #fed7aa" : "1.5px solid #bae6fd",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "24px",
            margin: "0 auto 14px auto",
            boxShadow: isLimitReached
              ? "0 4px 14px rgba(234, 88, 12, 0.15)"
              : "0 4px 14px rgba(2, 132, 199, 0.15)",
          }}
        >
          {isLimitReached ? <WarningOutlined /> : <IdcardOutlined />}
        </div>

        {/* Title */}
        <h3
          style={{
            fontSize: "19px",
            fontWeight: 600,
            color: "#0f172a",
            marginBottom: "8px",
            letterSpacing: "-0.2px",
          }}
        >
          {isLimitReached ? "Seat Limit Reached" : "Subscription Required"}
        </h3>

        <p
          style={{
            fontSize: "13.5px",
            color: "#64748b",
            lineHeight: 1.5,
            marginBottom: "16px",
            padding: "0 4px",
          }}
        >
          {isLimitReached
            ? "You have allocated all available seats in your current plan. Add extra seats to register more team members."
            : "An active Installer Pro Access plan is required to add certified installers to your team."}
        </p>

        {/* Quota Stats Box (for limit reached) */}
        {isLimitReached && (
          <div
            style={{
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: "12px",
              padding: "12px 16px",
              marginBottom: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ textAlign: "left" }}>
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  display: "block",
                  marginBottom: "2px",
                }}
              >
                Current Seat Usage
              </span>
              <span style={{ fontSize: "14.5px", fontWeight: 600, color: "#0f172a" }}>
                {usedSeats} of {totalSeats} Seats Used
              </span>
            </div>

            <span
              style={{
                fontSize: "12px",
                fontWeight: 700,
                color: "#dc2626",
                background: "#fef2f2",
                border: "1px solid #fecaca",
                borderRadius: "20px",
                padding: "3px 10px",
              }}
            >
              100% Full
            </span>
          </div>
        )}

        {/* Action Buttons */}
        <div className="modal-actions-responsive">
          <Button
            onClick={onClose}
            style={{
              flex: 1,
              height: "42px",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "13.5px",
              borderColor: "#cbd5e1",
              color: "#475569",
            }}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            icon={isLimitReached ? <PlusOutlined /> : <IdcardOutlined />}
            onClick={handleAction}
            style={{
              flex: 1.3,
              height: "42px",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "13.5px",
              background: "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
              borderColor: "transparent",
              boxShadow: "0 3px 10px rgba(2, 132, 199, 0.3)",
            }}
          >
            {isLimitReached ? "Add More Seats" : "Choose Plan"}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SeatGatekeeperModal;
